<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>{{ $t("org.billing.Product Cost") }}</h4>
            </div>
            <a
                v-if="!noData && status !=='loading'" class="text-right"
                href="javascript:;"
                @click="handleMoreButton"
            >
                <span
                    class="font-small-4 card-btn-more"
                >
                    {{ $t('org.dashboard.more') }}
                </span>
            </a>
        </div>
        <div class="b-table-sticky-header table-responsive table-all-consolidated">
            <b-table-simple
                no-border-collapse
            >
                <b-thead>
                    <b-tr>
                        <b-th
                            style="width:100px;"
                        >
                            {{ $t('v4.Product') }}
                        </b-th>
                        <b-th
                            style="width:100px;"
                            class="text-right"
                        >
                            {{ $t('v4.Cost') }}
                        </b-th>
                        <b-th
                            style="width:100px;"
                            class="text-right"
                        >
                            {{ $t('v4.Ratio') }}
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody v-if="status !== 'loading'">
                    <b-tr v-for="(item, index) in data" :key="index">
                        <b-td>
                            {{ item.productCode }}
                        </b-td>
                        <b-td class="text-right text-nowrap">
                            {{ $_getDollar(item.cost) }}
                        </b-td>
                        <b-td class="text-right text-nowrap">
                            {{ $_getRatio((item.cost/sumCost) * 100) }}
                        </b-td>
                    </b-tr>
                    <b-tr v-if="noData">
                        <b-td colspan="3" style="text-align:center;">
                            <div class="d-flex justify-content-center align-items-center flex-column text-center">
                                <SVGEmptyIcon/>
                                <span>{{ $t('org.dashboard.No data') }}</span>
                            </div>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </b-card>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        SVGEmptyIcon
    },
    props: {
        status: {
            type: [Number, String],
            default: ''
        },
        data: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const { data } = toRefs(props)
        const noData = computed(() => !data.value.length)
        const sumCost = computed(() => {
            return data.value.map(item => item.cost).reduce((accumulator, currentValue) => {
                accumulator += currentValue || 0
                return accumulator
            }, 0)
        })
        const handleMoreButton = () => {
            context.emit('click:more')
        }
        return {
            noData,
            sumCost,
            handleMoreButton
        }
    }
}
</script>

<style>
.table-all-consolidated {
    margin-bottom: 0.5rem;
}
</style>
